import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { useResolveFamilyExport } from "services/public";

type State = "loading" | "ready" | "expired";

export default () => {
  const { token } = useParams();
  const { request } = useResolveFamilyExport();
  const [state, setState] = useState<State>("loading");
  const [downloadUrl, setDownloadUrl] = useState<string>("");
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;
    if (!token) {
      setState("expired");
      return;
    }
    (async () => {
      const response = await request({ token });
      if (response?.downloadUrl) {
        setDownloadUrl(response.downloadUrl);
        setState("ready");
        // Kick off the download automatically.
        window.location.href = response.downloadUrl;
      } else {
        setState("expired");
      }
    })();
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        padding: "24px",
        textAlign: "center",
      }}
    >
      {state === "loading" && (
        <>
          <CircularProgress />
          <Typography variant="body">Preparing your download…</Typography>
        </>
      )}

      {state === "ready" && (
        <>
          <Typography variant="title">Your export is ready</Typography>
          <Typography variant="body" color="text.secondary">
            Your download should begin automatically. If it doesn't, use the
            button below.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.assign(downloadUrl)}
          >
            Download PDF
          </Button>
        </>
      )}

      {state === "expired" && (
        <>
          <Typography variant="title">This link has expired</Typography>
          <Typography variant="body" color="text.secondary">
            Export download links are valid for 30 days. Please ask your advisor
            to generate a new export.
          </Typography>
        </>
      )}
    </Box>
  );
};
